import { Component, Inject, Optional } from '@angular/core';
import { MessageTransportService } from '@nx-fe/services';
import { CellRendererBase, CellRendererData, CELL_RENDERER_TOKEN } from '../cell-renderer';
import { IconCellData, IconCellIcon } from '../renderer.models';

@Component({
  selector: 'ins-icon-image-cell-renderer',
  templateUrl: './icon-image-cell-renderer.component.html',
  styleUrls: ['./icon-image-cell-renderer.component.scss'],
})
export class IconImageCellRendererComponent extends CellRendererBase {
  icons: IconCellIcon[];

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    params: CellRendererData<object | boolean | string | number>,
    protected _eventTransportService: MessageTransportService
  ) {
    super(params, _eventTransportService);
  }

  static getIconsToRender(data): IconCellIcon[] {
    // TODO - We might have to force the default 'insight-icon-device' if no explicit icon is specified
    if (data && data.icons && data.icons.length > 0) {
      return data.icons;
    }
    return [{ iconClass: 'insight-icon-device' }];
  }

  init(cellData: CellRendererData<IconCellData>) {
    this.icons = IconImageCellRendererComponent.getIconsToRender(cellData.data);
  }
}
